import { Snackbar } from "@material-ui/core";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import { useEffect, useState } from "react";
import React from "react";
import $ from "jquery";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import UtilsFormule from "../../utils/UtilsFormule";
import { Link, useNavigate, useParams } from "react-router-dom";
import RateService from "../../services/RateService";
import WarehouseService from "../../services/WarehouseService";
import Societe from "../../services/Societe";
import SellingService from "../../services/SellingService";
import withLoader from "../../components/layouts/WithLoader";
const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});
function restructureData(array) {
  return array.map(item => {
    const { product, ...rest } = item; // Destructure to separate product and other fields
    if (product) {
      const { productCode, name, description, ...restProduct } = product; // Extract the needed fields
      return {
        ...rest,
        productCode, // Move productCode directly here
        productRef: name,         // Move name directly here
        description,  // Move description directly here
        // Add other fields from product that are necessary (example: barcode, sku, etc.)
        barcode: product.barcode,
        sku: product.sku,
        imagePath: product.imagePath,
        isComplited: product.isComplited,
        typeProduct: product.typeProduct,
        userCreation: product.userCreation
      };
    }
    return item; // In case there's no product object
  });
}
function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};



const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const EditBDCSell = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [productId, setProductId] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [tva, setTva] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  const [lineNote, setLineNote] = useState("");
  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [ordreDateLimite, setOrdreDateLimite] = useState("any");


  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [edit, setEdit] = useState(false);


  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();

  const [selectedOption, setSelectedOption] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);

  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [allAvailableBDC, setAllAvailableBDC] = React.useState([{}]);
  const [availableBDCSelectPlaceHolder, setAvailableBDCSelectPlaceHolder] =
    useState("Choisir...");


  const [
    allAvailableDevisNotRelatedToBdc,
    setAllAvailableDevisNotRelatedToBdc,
  ] = React.useState([{}]);
  const [
    availableDevisNotRelatedToBDCSelectPlaceHolder,
    setAvailableDevisNotRelatedToBDCSelectPlaceHolder,
  ] = useState("Choisir...");

  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [selectedIdProduct, setSelectedIdProduct] = useState(null);


  const [modeProduct, setModeProduct] = useState(null);

  const [clients, setClients] = useState([]);
  const [rateTableData, setRateTableData] = useState([]);

  const [labelDevise, setLabelDevise] = useState("Prix en DNT");
  const [montantDevis, setMontantDevis] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [availableLot, setAvailableLot] = useState([]);
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [allLot, setAllLot] = useState([]);
  const [idLot, setIdLot] = useState(0);
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [promotionPercentage, setPromotionPercentage] = useState(0);

  const [availableRates, setAvailableRates] = useState([]);
  const [documentProducts, setDocumentProducts] = useState([]);

  const [allRates, setAllRates] = useState([]);
  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [estimUnitPrice, setEstimUnitPrice] = useState("");
  const [estimQte, setEstimQte] = useState("");
  const [estimTva, setEstimTva] = useState("");
  const [estimDevise, setEstimDevise] = useState("");
  const [productBloc, setProductBloc] = useState(false);
  const [allClients, setAllClients] = useState([]);
  const [onGetStockProduct, setOnGetStockProduct] = useState(false);
  const [nameProductStock, setNameProductStock] = useState();
  const [BCId, setBCId] = useState();

  const handelNew = () => {
    setQuantity(0)
    setEstimTva("")
    setEdit(false)
    setEstimUnitPrice("")
    setNameProductStock("");

  }
  const onUpdateHandler = () => {

    const data = {
      "idBDC": BCId,
      "idUser": getCurrentUserId(),
      "sales": productTableData
    }
    // console.log(data)
    SellingService.updateBDCSale(data).then((response) => {
      console.log("response", response.data.success);
      // console.log(response.data.success.sales);
    })
      .catch((e) => {
        alert("error", e);
      })

  }
  useEffect(() => {

    // if (localStorage.getItem("status") == null) {
    //   setUserRole(["notConnected"]);
    // } else {
    //   setUserRole(JSON.parse(localStorage.getItem("status")));
    // }

    if (sessionStorage.getItem("typeDocument") === "devis") {
      startLoading()

      SellingService.getDevisByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("response", response.data.success);
          console.log(response.data.success.sales);

          setProductTableData(restructureData(response.data.success.sales))
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "bdc") {
      startLoading()

      SellingService.getBDCByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log(response.data.success.sales);
          setProductTableData(restructureData(response.data.success.sales))
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "facture") {
      startLoading()

      SellingService.getFactureByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log(response.data.success.sales);
          setProductTableData(restructureData(response.data.success.sales))
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    }

  }, []);
  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });

  useEffect(() => {

    Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((reponse) => {
        setClients(reponse.data["Societe"]);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : il ya un probléme pour obtenir les clients"
        );
      });
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });

    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    ).then((response) => {
      setAvailableLot(response.data);
    });

    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      1
    ).then((result) => {
      console.log("result", result.data["success"]);
      if (result.data["success"]) {
        setAvailableRates(result.data["success"]);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
  }, []);
  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);
  useEffect(() => {
    clients &&
      clients.map((element, i) => {
        let exist = false;
        if (allClients.length !== 0) {
          for (let index = 0; index < allClients.length; index++) {
            if (allClients[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllClients((oldArray) => [
            ...oldArray,
            {
              value: element.id, label: element.title, customElements: {
                seuil: element.seuil,
              }
            },
          ]);
        }
      });
  }, [clients]);

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              value: element.value,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);

  useEffect(() => {
    if (ordreDateLimite === ":59") {
      setOrdreDateLimite("any");
    }
  }, [ordreDateLimite]);

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };
  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setLabelDevise("Prix U en DNT");
    setEstimDevise(event.target.value)
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };
  const onChangeSelectedProduct = (selectedOptionn) => {
    console.log("selectedOptionn", selectedOptionn);
    setSelectedOption();
    setProductId(selectedOptionn?.value);
    setProductSelectPlaceHolder(selectedOptionn?.label);
    setEstimUnitPrice(selectedOptionn.customElements.price);
    setEstimQte(selectedOptionn.customElements.quantity);
    setEstimTva(selectedOptionn.customElements.tva);
    setEstimDevise(selectedOptionn.customElements.devise);
    setUnitPrice(selectedOptionn.customElements.price);
    setMontantDevis(selectedOptionn.customElements.price);
    setTva(selectedOptionn.customElements.tva);
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix.U.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },

    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "idProduct",
      text: "Stock",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            data-toggle="modal"
            data-target="#edit-brand"
          >
            <i class="fas fa-edit"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);
          setSelectedIdProduct(row.idProduct || row.id)
          setQuantity(row.quantity)
          setEstimTva(row.tva)
          setEdit(true)
          setEstimUnitPrice(row.sellingPrice)
          setLineNote(row.note || "")
          setNameProductStock(row.productRef);
          setOnGetStockProduct(true);
        },
      },
    },
    {
      dataField: "idProduct",
      text: "SUP",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct || item.id !== row.id)
          );
          setProductMapById(
            productMapById.filter((item) => item.idProduct !== row.idProduct || item.id !== row.id)
          );
        },
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const getProdcutsAndDevisByWarehouse = (event) => {
    if (warehouseSourceId !== 0) {
      startLoading();

      // setProductBloc(true);
      SellingService.getAllBDCNotArchived(getCurrentUserId(), warehouseSourceId)
        .then((response) => {
          if (Object.keys(response.data)[0] === "empty") {

          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element["ref"], label: element["ref"] };
              backendData.push(elem);
            });
            setAllAvailableBDC(backendData);
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + error);
        })
        .finally(() => {
          stopLoading()
        });
      startLoading();

      SellingService.getAllDevisNotRelatedToBDCeNotArchived(
        getCurrentUserId(),
        warehouseSourceId
      )
        .then((response) => {
          console.log("DevisBC", response);

          if (Object.keys(response.data)[0] === "empty") {
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element["ref"], label: element["ref"] };
              backendData.push(elem);
            });
            setAllAvailableDevisNotRelatedToBdc(backendData);
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        })
        .finally(() => {
          stopLoading()
        });

      startLoading();
      SellingService.getAllProductsOnSaleV2(
        getCurrentUserId(),
        1,
        warehouseSourceId
      )
        .then((response) => {
          if (response.data.success) {

            setAllProducts([{}]);
            response.data.success && setAllProducts(response.data.success);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : pas de dépôt");
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);

          setErrorAlertText("Erreur : " + e);
        })
        .finally(() => {
          stopLoading()
        });

      setProductBloc(true);
    }
  };
  const onChangePromotionHandler = (event) => {
    setPromotionPercentage(event.target.value);
  };
  useEffect(() => {
    const refDocument = sessionStorage.getItem("refDocument");

    if (!refDocument) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune référence");
      return;
    }

    SellingService.getBDCByRef(refDocument, getCurrentUserId())
      .then((response) => {
        console.log("getBDCByRef", response.data.success.id);
        setBCId(response.data.success.id)

        if (response.data.success) {
          const sales = response.data.success.sales.map((element) => {
            const lot = element.manufacturingBatch?.id || 0;
            return {
              productRef: element.product.name,
              idProduct: element.product.id,
              initialPriceHtc: element.initialPriceHtc,
              quantity: element.quantity,
              tva: element.tva,
              sellingPrice: element.sellingPrice,
              idLot: lot,
              currency: element.currency,
              currencyPrice: element.currencyPrice,
              exchangeRate: element.exchangeRate,
              isImport: element.isImport,
              htPrice: element.sellingPrice * element.quantity,
              ttPrice: element.priceTt * element.quantity,
              promotionPercentage: element.promotionPercentage,
              note: element.note,
            };
          });

          setProductMapById(sales);
          setProductTableData(sales);

          const rates = response.data.success.ratePPs.map((element) => ({
            idRate: element.idRate,
            name: element.name,
            value: element.value,
            code: element.code,
            type: element.type,
            typeTax: element.typeTax,
            typeTVA: element.typeTVA,
            refBill: element.refBill,
          }));

          setRateTableData(rates);
        } else if (response.data.empty) {
          setOpenInfoAlert(true);
          setInfoAlertText("Info : Aucun bon de commande avec cette référence");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Problème de connexion");
      });
  }, []);
  const onEditToList = () => {
    console.log(productTableData);

    const updatedProductTableData = productTableData.map((product) =>
      product.idProduct === selectedIdProduct
        ? {
          ...product,
          quantity,
          tva: estimTva,
          sellingPrice: estimDevise
        }
        : product
    );
    setEdit(false);
    setProductTableData(updatedProductTableData);

  };



  function blocProducts() {
    return (
      <div>
        <div class="row">
          <div className="col-sm-12">


            <div>

              {!edit &&
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div>
                        <label>
                          Choisir un produit{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedProduct}
                          options={allProducts}
                          placeholder={productSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>}
              <div class="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Prix.U.H.T ( {estimDevise})
                    </label>
                    <input
                      onChange={onChangeUnitPriceHandler}
                      value={estimDevise}
                      // disabled="true"
                      min="0"
                      id="unitPrice"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      TVA ({estimTva}%)
                    </label>
                    <input
                      value={estimTva}
                      disabled="true"
                      onChange={onChangeTvaHandler}
                      min="0"
                      id="tva"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Quantité
                      {/* <span style={{ color: "red" }}>*</span> (
                            {estimQte}) */}
                    </label>
                    <input
                      onChange={onChangeQuantityHandler}
                      value={quantity}
                      type="number"
                      min="0"
                      id="inputClientCompany"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Choisir un Lot</label>

                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={selectedOptionLot}
                      onChange={onChangeSelectedLot}
                      options={allLot}
                      placeholder={lotSelectPlaceHolder}
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Choisir le type de promotion</label>
                    <select
                      value={promotionType}
                      onChange={(e) => setPromotionType(e.target.value)}
                      className="form-control select2"
                      style={{ width: "100%" }}
                    >
                      <option key={1} value={"pourcentage"} selected="selected">
                        Pourcentage
                      </option>
                      <option key={2} value={"montant"}>
                        Montant
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">Promotion</label>
                    <input
                      value={promotionPercentage}
                      onChange={onChangePromotionHandler}
                      type="number"
                      min="0"
                      id="promotion"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="lineNote">Note du produit (facultatif)</label>
                    <textarea
                      id="lineNote"
                      rows={2}
                      maxLength={500}
                      value={lineNote}
                      onChange={(e) => setLineNote(e.target.value)}
                      className="form-control"
                      placeholder="Remarque propre à cette ligne (texte libre)"
                    />
                  </div>
                </div>

              </div>

              <div class="row">
                {!edit ? <div className="col-sm-12  text-center">
                  <button
                    style={{ marginBottom: 20 }}
                    className="btn btn-dark"
                    onClick={onAddProductToList}
                  >
                    <i class="fas fa-plus"></i>
                    Liste des ventes{" "}
                  </button>
                </div> :
                  <div className="col-sm-12  text-center">
                    <button
                      style={{ marginBottom: 20 }}
                      className="btn btn-dark"
                      onClick={onEditToList}
                    >
                      <i class="fas fa-edit"></i>
                      Edit Liste des ventes{" "}
                    </button>
                  </div>}
              </div>

              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    {productTableData && (
                      <ToolkitProvider
                        keyField="idProduct"
                        data={productTableData}
                        columns={columnsWithDelete}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  className="btn btn-dark float-right"
                  onClick={onUpdateHandler}
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    );

  }
  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        console.log("element", element);
        if (element.idProduct === productId) {
          indexInDataTable = index;
          productRef = element.productRef;
          exist = true;
          console.log("productMapById indexInDataTable", indexInDataTable);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    try {
      allProducts.forEach((element) => {
        if (element.value === productId) {
          productRef = element.customElements.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit ");
    } else {
      if (modeProduct === 0) {
      }
      let result = UtilsFormule.CalculatePromotionProductPurchase(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      console.log("result add product table", result);
      let promotionAmountOrPersentage = result[0];
      let sellingPrice = result[1];
      let promotionpercent = result[2];
      let ttPrice = Math.round((result[3] * 1000) / 1000);

      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            sellingPrice: sellingPrice,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            sellingPrice: sellingPrice,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.sellingPrice = sellingPrice;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = Math.round((ttPrice * 1000) / 1000);
        productUpdateValue.note = lineNote;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " + productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " + productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    console.log("productTableData ", productTableData);
  };
  useEffect(() => {
    if (sessionStorage.getItem("typeDocument") === "devis") {
      startLoading()

      SellingService.getDevisByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("response", response.data.success);
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "bdc") {
      startLoading()

      SellingService.getBDCByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "facture") {
      startLoading()

      SellingService.getFactureByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error", e);
        }).finally(() => {
          stopLoading()
        });
    }

  }, []);
  function etatInitial() {
    setLineNote("");
    setSelectedOption(null);
    setProductSelectPlaceHolder("Choisir...");
    setUnitPrice(0);
    setQuantity(0);
    setTva(0);
    setSelectedOptionMode(null);
    setPromotionType("pourcentage");
    setPromotionPercentage(0);
    setSelectedOptionLot(null);
    setLotSelectPlaceHolder("Choisir...");
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <section className="content-header">
            <div className="container-fluid">
              <div class="card card-dark">
                <div class="card-body">
                  <div className="row">
                    <div className="col-md-10">
                      <h5 class="card-title">
                        Bon de commande: {documentProducts.reference}
                      </h5>
                    </div>
                    <div className="col-md-2">
                      {" "}
                      <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                      {documentProducts.creationDate}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="row">
            <div className="col-md-3 col-sm-6 col-12">
              <div className="info-box bg-gray ">
                <span className="info-box-icon">
                  <i class="fas fa-user"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Client</span>
                  <span className="info-box-number">
                    {documentProducts?.clientTitle}
                  </span>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{ width: "70%" }}
                    />
                  </div>

                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-12">
              <div className="info-box bg-gray ">
                <span className="info-box-icon">
                  <i class="fas fa-dollar-sign"></i>{" "}
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Prix TTC</span>
                  <span className="info-box-number">
                    {documentProducts.ttPrice} DNT
                  </span>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{ width: "70%" }}
                    />
                  </div>
                  <span className="progress-description">
                    {documentProducts.htPrice} DNT prix HT
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 col-12">
              <div className="info-box bg-gray-dark ">
                <span className="info-box-icon">
                  <i class="fas fa-chart-line"></i>{" "}
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Prix de vente</span>
                  <span className="info-box-number">
                    {documentProducts.buyingPrice} DNT
                  </span>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{ width: "70%" }}
                    />
                  </div>
                  {documentProducts.discountPercentage !== 0 && (
                    <span className="progress-description">
                      Promotion de{documentProducts.discountPercentage}%{" "}
                    </span>
                  )}
                  {documentProducts.discountPercentage === 0 && (
                    <span className="progress-description">
                      {documentProducts.htPrice} DNT prix HT
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 col-12">
              <div className="info-box  bg-black">
                <span className="info-box-icon">
                  <i class="fas fa-shopping-cart"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Produits</span>

                  {documentProducts.sales && (
                    <span className="info-box-number">
                      {documentProducts.sales.length}{" "}
                    </span>
                  )}
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{ width: "100%" }}
                    />
                  </div>
                  {documentProducts.sales && (
                    <span className="progress-description">
                      {documentProducts.sales.length}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li className="breadcrumb-item">
                  <Link to="/bonCommandeVente" style={{ color: "black" }}>
                    Les bons de commandes
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Modifier
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div>
                  <div class="card-body">
                    <div>
                      <div class="row">
                        <div className="col-sm-12">
                          {edit ? <button
                            style={{ marginBottom: 20 }}
                            className="btn btn-dark"
                            onClick={handelNew}
                          >
                            <i class="fas fa-plus"></i>
                            {" "} Ajouter nouveau produit
                          </button> :
                            <div className="form-group">
                              <label>
                                Choisir le dépôt <span style={{ color: "red" }}>*</span>
                              </label>
                              <div className="input-group">
                                <div
                                  className="input-group-prepend"
                                  style={{ width: "95%" }}
                                >
                                  <Select
                                    styles={styles}
                                    closeMenuOnSelect={true}
                                    components={animatedComponents}
                                    defaultValue={selectedOption}
                                    onChange={onChangeSelectedWarehouseSource}
                                    options={allWarehouseSource}
                                    placeholder={warehouseSelectPlaceHolder}
                                  />
                                </div>
                                <div className=" input-group-append">
                                  <button
                                    onClick={getProdcutsAndDevisByWarehouse}
                                    type="button"
                                    class="btn btn-dark"
                                  >
                                    <i class="fas  fa-solid fa-arrow-down"></i>
                                  </button>
                                </div>
                              </div>
                            </div>}
                        </div>
                      </div>
                      {blocProducts()}

                      {/*  */}
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(EditBDCSell);
